import * as React from 'react'

const SvgMessage = (props) => (
  <svg
    width={30}
    height={30}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.35}
      d='M13.125 2.5C7.258 2.5 2.5 7.258 2.5 13.125c0 1.691.405 3.284 1.109 4.704l-1.068 4.27a1.327 1.327 0 0 0 1.61 1.61l4.27-1.068a10.556 10.556 0 0 0 4.704 1.109c5.867 0 10.625-4.758 10.625-10.625S18.992 2.5 13.125 2.5Z'
      fill='#101AA1'
    />
    <path
      d='m25.87 19.496 1.59 6.353a1.327 1.327 0 0 1-1.61 1.61l-6.353-1.59 6.374-6.373Z'
      fill='#101AA1'
    />
    <path
      d='M22.267 7.732a10.547 10.547 0 0 1 1.483 5.393c0 5.867-4.758 10.625-10.625 10.625-1.971 0-3.811-.546-5.393-1.483 1.85 3.13 5.247 5.233 9.143 5.233 5.867 0 10.625-4.758 10.625-10.625 0-3.896-2.104-7.294-5.233-9.143Z'
      fill='#101AA1'
    />
  </svg>
)

export default SvgMessage
